import { render } from "./modalEdit.vue?vue&type=template&id=00a367dc&ts=true"
import script from "./modalEdit.vue?vue&type=script&lang=ts"
export * from "./modalEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__